import request from '@/utils/request'

// 生产设置--列表页
export function pageProductConfig(params) {
  return request({
    url: '/v3/manager/productConfig/pageProductConfig',
    method: 'post',
    data: params
  })
}
// 生产设置--新增
export function add(params) {
  return request({
    url: '/v3/manager/productConfig/add',
    method: 'post',
    data: params
  })
}
// 生产设置--编辑
export function updateById(params) {
  return request({
    url: '/v3/manager/productConfig/updateById',
    method: 'post',
    data: params
  })
}

export function listBaseYhubInfoByProductId(params) {
  return request({
    url: '/v3/manager/productConfig/listBaseYhubInfoByProductId?productId=' + params,
    method: 'get',
    data: {}
  })
}
// 更新状态信息
export function updateStatusById(params) {
  return request({
    url: '/v3/manager/productConfig/updateStatusById',
    method: 'post',
    data: params
  })
}
// 获取生产订单log列表
export function getProductLog(mcuId) {
  return request({
    url: '/v3/manager/productConfig/getProductLog?mcuId=' + mcuId,
    method: 'post',
    data: {mcuId}
  })
}
// 获取生产订单详情
export function getProductConfigSimple(params) {
  return request({
    url: '/v3/manager/productConfig/getProductConfigSimple?productConfigId=' + params.productConfigId,
    method: 'get',
    data: params
  })
}
// 转移生产订单中的设备
export function transferProduct(params) {
  return request({
    url: '/v3/manager/productConfig/transferProduct',
    method: 'post',
    data: params
  })
}
// 删除生产订单中的设备
export function deleteProductByYhubSn(params) {
  return request({
    url: '/v3/manager/productConfig/deleteProductByYhubSn',
    method: 'post',
    data: params
  })
}

// 根据生产订单获取临时绑定信息
export function tmpBindList(params) {
  return request({
    url: '/v3/manager/productConfig/getProductBindList?productConfigId=' + params,
    method: 'get',
    data: {}
  })
}
// 获取软硬件版本
export function listDeviceVersion(params) {
  return request({
    url: '/v3/manager//productConfig/listDeviceVersion',
    method: 'get',
    data: {}
  })
}
// 批量更新固件版本
export function batchUpdate(params) {
  return request({
    url: 'v3/manager/deviceManage/batchUpdate',
    method: 'post',
    data: params
  })
}
// 获取固件的更新速度
export function getFwUpdateProgress(params) {
  return request({
    url: 'v3/manager/deviceManage/getFwUpdateProgress',
    method: 'post',
    data: params
  })
}
// 根据生产订单推送配置
export function updateDeviceConfig(params) {
  return request({
    url: 'v3/manager/productConfig/updateDeviceConfig',
    method: 'post',
    data: params
  })
}
// 根据生产订单推送警告配置
export function updateDeviceWarningSetting(params) {
  return request({
    url: 'v3/manager/productConfig/updateDeviceWarningSetting',
    method: 'post',
    data: params
  })
}
// 获取测试日志
export function findManufactureTestLog(params) {
  return request({
    url: 'v3/manager/baseYhubInfo/findManufactureTestLog',
    method: 'post',
    data: params
  })
}

// 批量修改公司归属
export function batchChangeCompany (data) {
  return request({
    url: 'v3/manager/deviceManage/batchChangeCompany',
    method: 'post',
    data
  })
}

// 导出Yhub基础数据
export function exportYhubBaseData(sns) {
  return request({
    url: '/v3/manager/device/exportYhubBaseData?sns=' + sns,
    method: 'get',
    data: {}
  })
}
